import { ActionContext } from 'vuex';
import $rq from '@/api/api';
import type { RootState } from '@/interfaces/store';
import { NetworkOrComponentState } from '@/interfaces/common';

const defaultState = (): NetworkOrComponentState => ({});

const mutations = {
    setComponentState(state: NetworkOrComponentState, component: NetworkOrComponentState) {
        Object.assign(state, component);
    },
    resetComponentState(state: NetworkOrComponentState) {
        Object.keys(state).forEach((key) => {
            delete state[key];
        });
    },
};

const actions = {
    async getComponentInfo(
        { commit, dispatch }: ActionContext<NetworkOrComponentState, RootState>,
        componentId: string,
    ) {
        try {
            const { data } = await $rq.getComponentInfo(componentId);
            commit('setComponentState', data as NetworkOrComponentState);
        } catch (err) {
            dispatch('resetComponentInfo');
        }
    },
    resetComponentInfo({ commit }: ActionContext<NetworkOrComponentState, RootState>) {
        commit('resetComponentState');
    },
};

const getters = {
    component: (state: NetworkOrComponentState): NetworkOrComponentState => state,
};

const state: NetworkOrComponentState = defaultState();

export default {
    state,
    getters,
    actions,
    mutations,
};
